import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';

function formatSummary(summary) {
  if (!summary) return '';
  try {
    const obj = typeof summary === 'string' ? JSON.parse(summary) : summary;
    return Object.entries(obj)
      .map(([k, v]) => `${k}: ${v}`)
      .join(' · ');
  } catch {
    return String(summary);
  }
}

export default function ConsignmentChangeLogTimeline({ entries }) {
  const { translate } = useTranslation();
  const list = entries || [];

  if (list.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        {translate('consignment.change_log_empty')}
      </Typography>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      {list.map((entry) => (
        <Paper key={entry.id} variant="outlined" sx={{ p: 1.5 }}>
          <Typography variant="caption" color="text.secondary" display="block">
            {entry.created_at} · {entry.created_by || '—'} · {translate(`consignment.change_action_${entry.action.toLowerCase()}`)}
          </Typography>
          {entry.summary && (
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              {formatSummary(entry.summary)}
            </Typography>
          )}
          {entry.observation && (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5, fontStyle: 'italic' }}>
              {entry.observation}
            </Typography>
          )}
        </Paper>
      ))}
    </Box>
  );
}
